import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { quoteFormSelector } from 'ctm-selectors';
import { QuoteCard } from '../quote_card';
import { QuoteQuestionPlainItem } from '../quote_question_plain_item';
import { formatAddress } from 'ctm-components/components/address/utils';

export const getParkingTypeLabel = (value) => ({
    GARAGED: 'Garaged',
    CAR_PARK: 'Car Park',
    STREET: 'Street',
    PARKING_LOT: 'Parking Lot',
    DRIVEWAY: 'Driveway',
    LOCKED_COMPOUND: 'Locked Compound',
    ON_PRIVATE_PROPERTY: 'On Private Property',
    CAR_PORT: 'Carport'
}[value]);

const _Address = (props) => {
    const { overnightParkingType, overnightParkingPostcode, buildingName, unitType, unitNumber, streetNumber, streetName, suburb } = props;

    return (
        <QuoteCard title="Address" path="car_address">
            <QuoteQuestionPlainItem title="Postcode" content={overnightParkingPostcode} />
            <QuoteQuestionPlainItem title="Address" content={formatAddress({ buildingName, unitType, unitNumber, streetNumber, streetName, suburb })} />
            <QuoteQuestionPlainItem title="Parking" content={getParkingTypeLabel(overnightParkingType)} />
        </QuoteCard>
    );
};

_Address.propTypes = {
    buildingName: PropTypes.string,
    unitType: PropTypes.string,
    unitNumber: PropTypes.string,
    streetNumber: PropTypes.string,
    streetName: PropTypes.string,
    suburb: PropTypes.string,
    overnightParkingType: PropTypes.string,
    overnightParkingPostcode: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        buildingName: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'address', 'buildingName']),
        unitType: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'address', 'unitType']),
        unitNumber: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'address', 'unitNumber']),
        streetNumber: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'address', 'streetNumber']),
        streetName: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'address', 'streetName']),
        suburb: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'address', 'suburb']),
        overnightParkingPostcode: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'address', 'postcode']),
        overnightParkingType: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'parkingType'])
    };
};

const Address = connect(mapStateToProps)(_Address);

export { Address, _Address };
